(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // メイン画像とサムネイル画像を取得
  const mainImage = document.querySelector('.showroom_slider_main img');
  const thumbnails = document.querySelectorAll('.showroom_slider_subs img');
  
  // サムネイルそれぞれにクリックイベントを追加
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      // クリックされたサムネイルにactiveクラスを追加
      this.classList.add('active');
      
      // クリックされたサムネイルの画像URLをメイン画像にセット
      mainImage.src = this.src;
      mainImage.alt = this.alt;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
